import React from "react";
import { useParams } from "react-router-dom";
import useFileDocuments from "../actions/useFileDocuments";

const TitleBreadcrumbs = () => {
  const { id, service_id, process_id, type, request_type, request_id } =
    useParams();
  const { states, handleBackClick } = useFileDocuments({
    id,
    service_id,
    type,
    process_id,
    request_type,
    request_id,
  });

  const {
    selectedService,
    selectedProcess,
    selectedType,
    selectedRequestType,
    selectedRequest,
    isPayslipFolder,
  } = states || {};

  const breadcrumbs = [
    "Files & Documents",
    service_id && selectedService?.name,
    type && selectedType?.name,
    process_id && selectedProcess?.name,
    request_type && selectedRequestType?.name,
    request_id && selectedRequest?.name,
    isPayslipFolder && "Payslips",
  ].filter(Boolean);
  return (
    <div className="title-breadcrumbs">
      <div className="flex align-items-center">
        {service_id && (
          <i
            className="pi pi-arrow-left folder-back-icon"
            onClick={handleBackClick}
          />
        )}
        <p>
          {breadcrumbs.slice(0, -1).map((crumb, index) => (
            <span key={index} className="document-heading">
              {crumb} /{" "}
            </span>
          ))}
          {breadcrumbs.length > 0 && (
            <span className="document-bold-heading">{breadcrumbs.at(-1)}</span>
          )}
        </p>
      </div>
    </div>
  );
};

export default TitleBreadcrumbs;
